import * as constants from '../constants';
import { ACTION } from './index';

export enum Types {
  journey1 = 'journey1',
  journey2 = 'journey2',
  journey3 = 'journey3',
}

export interface TypeContainer {
  type: keyof typeof Types;
  isJourney1: boolean;
  isJourney2: boolean;
  isJourney3: boolean;
  url: string;
}

export const setType = (type: keyof typeof Types, url?: string): ACTION => ({
  type: constants.SET_TYPE_CONTAINER,
  payload: { type, url },
});
